import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatNumber(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`
  return n.toString()
}

export function timeAgo(date: Date): string {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  if (seconds < 60) return `${seconds}s ago`
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`
  return `${Math.floor(seconds / 86400)}d ago`
}

// All AI provider costs are computed and stored server-side in USD, since
// that's the currency Anthropic/OpenAI/Gemini actually bill in -- converting
// at storage time would compound drift into historical figures every time
// the rate changes. This converts only at the point of display. Rate is a
// reasonable current approximation (~0.75, verified July 2026, USD/GBP
// typically moves within a few percent week to week) -- not a live, quoted
// rate, so treat displayed £ figures as a close approximation, not exact to
// the penny against the real-time market rate.
const USD_TO_GBP_RATE = 0.75

export function formatGbp(usd: number): string {
  return `£${(usd * USD_TO_GBP_RATE).toFixed(2)}`
}
